import md5 from 'js-md5';
import { GetUserAllSettings } from '../../http/api';
export default {
  data() {
    return {
      show: false,
      flag: false,
      loginLoad: false,
      env: this.$ENV,
      ruleForm: {
        userName: '',
        passWord: '',
      },
      redirect: undefined,
      otherQuery: {},
      rules: {
        userName: [
          {
            required: true,
            message: '账号不能为空',
            trigger: ['change', 'blur'],
          },
        ],
        passWord: [
          {
            required: true,
            message: '密码不能为空',
            trigger: ['change', 'blur'],
          },
        ],
      },

    };
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  methods: {
    loginEvent() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loginLoad = true;
          this.$store
            .dispatch('actionsLogin', {
              userName: this.ruleForm.userName,
              passWord: md5(this.ruleForm.userName + this.ruleForm.passWord),
            })
            .then((isValid) => {
              if (isValid) {
                this.$prompt('请输入密码', '二次验证', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputPattern: /\w{6,}/,
                  inputErrorMessage: '密码不能为空',
                }).then(({ value }) => {
                  this.$store
                    .dispatch('actionAuthLogin', {
                      userName: this.ruleForm.userName,
                      passWord: md5(this.ruleForm.userName + value),
                    })
                    .then((_) => {
                      this.$router.push('/layout/home');
                      GetUserAllSettings().then((res) => {
                        localStorage.setItem('columnArr', JSON.stringify(res));
                      });
                    })
                    .finally((_) => (this.loginLoad = false));
                });
              } else {
                this.$router.push('/layout/home');
                GetUserAllSettings().then((res) => {
                  localStorage.setItem('columnArr', JSON.stringify(res));
                });
              }
            })
            .finally(() => {
              this.loginLoad = false;
            });
        }
      });
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    applyHandler() {
      console.log(123);
      this.isShowApplyDialog = true;
    },
  },
};